import React, { useEffect, useState } from 'react';
import {
  TextField,
  Grid,
  Card,
  Typography,
  Box,
  Stack,

} from '@mui/material';
import MDButton from 'components/MDButton';
import { useDispatch, useSelector } from 'react-redux';
import { openSnackbar } from '../../redux/slices/common';
import { useNavigate, useParams } from 'react-router-dom';
import { isEmptyObject } from 'utilities/common';
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../redux/slices/modalSlice';
import InputMask from 'react-input-mask';
import { addPhysician, deletePhysician, updatePhysician } from '../../redux/slices/physicianSlice';
import { physicianFormValidation } from 'validations/physician';
const AddPhysicianForm = () => {
  const { isLoading: loading = false, physicianDetail } = useSelector(state => state.physician);
  const { physicianId } = useParams();
  const { isUploading = false } = useSelector(state => state.common);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    status: true
  });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = physicianFormValidation(formData);
    if (!isValid) {
      setErrors(errors);
      return;
    }
    setErrors({});
    const payload = {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      email: formData?.email,
      status: formData?.status,
      phone: formData?.phone?.replace(/[^\d]/g, ''),
    };

    if (physicianId) {
      dispatch(updatePhysician({ data: payload, adminId: physicianId })).unwrap().then((res) => {
        showResponseMessage(res?.message, 'success');
        navigate('/manages/physician');
      }).catch((err) => {
        showResponseMessage(err?.message, 'error');
      });
    } else {
      dispatch(addPhysician(payload)).unwrap().then((res) => {
        showResponseMessage(res?.message, 'success');
        navigate('/manages/physician');
      }).catch((err) => {
        showResponseMessage(err?.message, 'error');

      });
    }
  };

  const showResponseMessage = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };


  const deleteHandler = (physicianId) => {
    dispatch(setModalLoader(true));
    dispatch(deletePhysician(physicianId)).unwrap().then((res) => {
      showResponseMessage(res?.message, 'success');
      dispatch(closeCustomModalDialog());
      navigate('/manages/physician');
    }).catch((err) => {
      dispatch(setModalLoader(false));
      showResponseMessage(err?.message, 'error');
    });
  };

  useEffect(() => {
    if (!isEmptyObject(physicianDetail)) {
      let payload = {
        ...physicianDetail, roles: physicianDetail?.userRoles || []
      };
      setFormData(payload);
    }
  }, [physicianDetail]);

  return (
    <Box p={{ xs: 2, sm: 3, lg: 4 }}>
      <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2} mb={4.5}>
          <Typography variant='h4' fontWeight="semibold" color="secondary">{physicianId !== 'add' ? 'Update' : 'Add New'} Physician</Typography>
          <Box display="flex" alignItems="center" gap={1.25}>
            <Typography variant='h5' fontWeight="semibold" color="secondary">Status</Typography>
            <Stack direction="row" alignItems="center" gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor="#F2F3F7">
              <MDButton
                sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                type='button'
                variant={formData?.status ? 'contained' : 'text'}
                color={formData?.status ? 'success' : 'dark'}
                size="small"
                onClick={() => setFormData({ ...formData, status: true })}
              >
                Active
              </MDButton>
              <MDButton
                sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                type='button'
                variant={!formData?.status ? 'contained' : 'text'}
                color={!formData?.status ? 'error' : 'dark'}
                size="small"
                onClick={() => setFormData({ ...formData, status: false })}
              >
                Inactive
              </MDButton>
            </Stack>
          </Box>
        </Stack>

        <Grid container spacing={2.5} mb={4.5}>
          <Grid item xs={12} md={6} lg={6}>
            <TextField className="form-input" error={errors?.firstName} helperText={errors.firstName} fullWidth label="First Name" name="firstName" value={formData?.firstName || ''} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <TextField className="form-input" error={errors?.lastName} helperText={errors.lastName} fullWidth label="Last Name" name="lastName" value={formData?.lastName} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <TextField className="form-input" error={errors?.email} helperText={errors.email} fullWidth label="Email" name="email" value={formData?.email} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <InputMask
              fullWidth
              label=""
              className="form-input"
              error={errors.phone}
              helperText={errors.phone}
              placeholder="Phone*"
              name="phone"
              value={formData?.phone}
              onChange={handleChange}
              mask='(999) 999-9999'
              maskChar=''
            >
              {(inputProps) => <TextField {...inputProps} disableUnderline />}
            </InputMask>
          </Grid>
        </Grid>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <MDButton
            sx={{ minWidth: '160px' }}
            type='button'
            variant='contained'
            color='primary'
            onClick={handleSubmit}
            disabled={isUploading || loading}
            loading={isUploading || loading}

          >
            {physicianId ? 'Update' : 'Save'}
          </MDButton>
          {
            physicianId && <MDButton
              sx={{ minWidth: '160px', backgroundColor: '#F1F1F1', color: '#FD4438' }}
              type='button'
              variant='contained'
              color='error'
              onClick={() => dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: physicianId }, modal: 'DELETE_MODAL' }))}
            >
              Delete
            </MDButton>
          }
          <MDButton
            sx={{ minWidth: '160px' }}
            type='button'
            variant='outlined'
            color='dark'
            onClick={() => navigate('/manages/physician')}
          >
            Cancel
          </MDButton>
        </Stack>
      </Card>
    </Box>
  );
};

export default AddPhysicianForm;